import React, { useCallback, useEffect, useMemo, useState } from "react";
import logoPath from "../../Assets/Images/MainLogo.svg";
import logoPathLight from "../../Assets/Images/MainLogoLight.svg";
import { useHistory, useLocation } from "react-router-dom";
import style from "./style.module.scss";
import { useAppHeaderTheme } from "../Header/useAppHeaderTheme";

/**
 * Static horizontal brand lockup (mark left; wordmark between rules with the
 * tagline beneath), matching the physical office signage. Replaces the old
 * scroll-driven grow/shrink logo so the header keeps one compact height.
 */
export const Logo = React.memo(
  (props: {
    isScrolling?: boolean;
    size?: number;
    onSizeChange?: (e: any) => any;
    withoutText?: boolean;
    withoutSubText?: boolean;
    selected?: boolean;
  }) => {
    const { onSizeChange, withoutText = false } = props;
    const [headerTheme] = useAppHeaderTheme();
    const history = useHistory();
    const location = useLocation();
    const [selected, setSelected] = useState(false);

    // The header lays itself out around the old logo's large/small states;
    // report the compact state once so it settles into that layout.
    useEffect(() => {
      onSizeChange?.(false);
    }, [onSizeChange]);

    useEffect(() => {
      setSelected(location.pathname === "/");
    }, [location.pathname]);

    const handleClick = useCallback(() => history.push("/"), [history]);

    const isLightTheme = useMemo(
      () => headerTheme === "transparent-start" && !props.isScrolling,
      [headerTheme, props.isScrolling]
    );

    return (
      <div
        onClick={handleClick}
        className={`${style.lockup} ${isLightTheme ? style.lockupLight : ""} ${
          !!!withoutText && selected ? style.selected : ""
        }`}
      >
        <img
          draggable="false"
          alt="Eagle Harbor Logo"
          className={style.lockupMark}
          src={isLightTheme ? logoPathLight : logoPath}
        />
        {!!!withoutText && (
          <span className={style.lockupText}>
            <strong className={style.lockupWordmark}>
              EAGLE HARBOR ADVISORS
              <sup className={style.registeredMark} aria-label="registered trademark">
                &reg;
              </sup>
            </strong>
            <strong className={style.tagline}>Plan &bull; Protect &bull; Prosper</strong>
          </span>
        )}
      </div>
    );
  }
);
